(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-type', {
            parent: 'entity',
            url: '/communication-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.communicationType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/communication-type/communication-types.html',
                    controller: 'CommunicationTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-type-detail', {
            parent: 'entity',
            url: '/communication-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.communicationType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/communication-type/communication-type-detail.html',
                    controller: 'CommunicationTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationType', function($stateParams, CommunicationType) {
                    return CommunicationType.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-type.new', {
            parent: 'communication-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-type/communication-type-dialog.html',
                    controller: 'CommunicationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('communication-type', null, { reload: true });
                }, function() {
                    $state.go('communication-type');
                });
            }]
        })
        .state('communication-type.edit', {
            parent: 'communication-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-type/communication-type-dialog.html',
                    controller: 'CommunicationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommunicationType', function(CommunicationType) {
                            return CommunicationType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('communication-type.delete', {
            parent: 'communication-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-type/communication-type-delete-dialog.html',
                    controller: 'CommunicationTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationType', function(CommunicationType) {
                            return CommunicationType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
